import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

export const SORT_OPTIONS = [
  { value: "featured", label: "Featured" },
  { value: "newest", label: "Newest" },
  { value: "price-asc", label: "Price: Low to High" },
  { value: "price-desc", label: "Price: High to Low" },
  { value: "title", label: "Alphabetical" },
];

export const SortSelect = ({ value, onChange }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className="w-[190px] rounded-none border-gray-300 text-xs font-bold uppercase tracking-widest h-11" data-testid="sort-select">
      <SelectValue placeholder="Sort" />
    </SelectTrigger>
    <SelectContent className="rounded-none">
      {SORT_OPTIONS.map((o) => (
        <SelectItem key={o.value} value={o.value} className="text-xs font-bold uppercase tracking-wide" data-testid={`sort-option-${o.value}`}>
          {o.label}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
